'use strict';

angular.module('study.ecrd.field.queries')
.component('fieldQueries', {
    templateUrl: 'modules/ecrd/components/field/queries/content.html',
    controller: 'FieldQueriesController',
    bindings: {
        fieldId: '<',
        // La versión actual de la entidad. Cuando cambie toca recargar las queries
        // entityVersion: '<',
    },
});
